import { Link } from 'react-router';

import { API_BASE_URL } from '@/lib/api';

export type IntranetHeroBannerProps = {
  title: string;
  /** API path from `IntranetAppearance.backgroundUrl`, or null for the navy fallback. */
  backgroundUrl: string | null;
  /** Local preview (object URL). When set, it is used instead of `backgroundUrl`. */
  imageSrc?: string | null;
  backgroundAlt: string | null;
  /** Editorial link. Omitted on the appearance page itself. */
  editHref?: string | null;
};

/**
 * 75% navy over the photo keeps white title text above WCAG AA even on a white image
 * (the overlay lands near `--brand-navy`). No image: the navy field itself, no `<img>`.
 */
export function IntranetHeroBanner({
  title,
  backgroundUrl,
  imageSrc,
  backgroundAlt,
  editHref,
}: IntranetHeroBannerProps) {
  const src = imageSrc ?? (backgroundUrl ? `${API_BASE_URL}${backgroundUrl}` : null);

  return (
    <div className="relative h-[120px] overflow-hidden rounded-xl bg-brand-navy lg:h-[168px]">
      {src ? (
        <img
          src={src}
          alt={backgroundAlt ?? ''}
          className="absolute inset-0 size-full object-cover object-top"
        />
      ) : null}
      {src ? <div className="absolute inset-0 bg-brand-navy/75" aria-hidden /> : null}
      <p className="relative z-10 flex h-full items-center justify-center px-16 text-center text-2xl font-semibold text-white lg:text-4xl">
        {title}
      </p>
      {editHref ? (
        <Link
          to={editHref}
          className="absolute bottom-3 left-3 z-10 inline-flex min-h-11 items-center rounded-md px-2 text-sm font-medium text-white underline-offset-4 hover:underline focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
        >
          Hintergrund ändern
        </Link>
      ) : null}
    </div>
  );
}
